// extracted by mini-css-extract-plugin
export default {"bgColorGradient":"wrapper_bgColorGradient__RaFMQ","padd":"wrapper_padd__s8sY6"};